/* import __COLOCATED_TEMPLATE__ from './edit-location-modal.hbs'; */
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import LSGModalBase from '../lsg/lsg-modal-dialog-base';
import { closeModal } from 'sh-www/utils/modal-controls';

/**
 * The modal that allows users to edit the location.
 */
export default LSGModalBase.extend({
  /**
   * Register services
   */
  applicationCommandService : service('commands/application-commands'),
  session: service(),
  store: service(),

  currentUser: readOnly('session.currentUser'),

  /**
   * Parameters to be passed in. Referenced by 'model.xxx'.
   */
  propertyDefaults: {
    /**
     * @param {Application}
     */
    application: null,

    /**
     * @param {Location}
     */
    selectedLocation: null,
  },

  /**
   * Private, internal state properties. Referenced by 'state.xxx'.
   */
  stateDefaults: {
    /**
     * @type {Location|null}    The city Location model selected by the user or null
     */
    cityLocation: null,
  },

  /**
   * @inheritDoc
   */
  _onInitializationComplete() {
    // Set the city location from the current application location (but only if it's not a country).
    if (
      this.get('model.selectedLocation')
      && this.get('model.selectedLocation.locationType') !== 'country'
    ) {
      this.set('state.cityLocation', this.get('model.selectedLocation'));
    }

    // Set the initial location text that is displayed.
    this.set('_updatedCityLocationText', this.state.cityLocation?.formattedAddress ?? '');
  },

  /**
   * @type {String} The city location text.
   */
  _updatedCityLocationText: null,

  _submitDisabled: computed(
    '_updatedCityLocationText',
    'state.cityLocation.formattedAddress',
    function() {
      return !this._updatedCityLocationText ||
        this._updatedCityLocationText !== this.state.cityLocation?.formattedAddress;
    }
  ),

  actions: {
    /**
     * Called when the user types in the field.
     */
    onLocationTextInput(value) {
      this.set('_updatedCityLocationText', value);
    },

    /**
     * Called when the user has clicked the cancel button.
     */
    onCancelClicked() {
      closeModal(this);
    },

    /**
     * Called when the user has clicked the update button.
     */
    onUpdateClicked() {
      // Update the location.
      this.model.onLocationUpdated(this.state.cityLocation);
      closeModal(this);
    },

    /**
     * Called when user has input a new location.
     *
     * @param {Location|null} locationRecord Location record that has not been saved.
     */
    onLocationRecordCreated: function(locationRecord) {
      this.setProperties({
        'state.cityLocation': locationRecord,
        '_updatedCityLocationText': locationRecord?.formattedAddress ?? '',
      });
    },
  },
});
